import React, { useEffect } from "react";
import { Auth } from "aws-amplify";

const LoginPage: React.FC = () => {
  const isGen2Test = window.location.hostname === "gen2.legendsfield.net" || window.location.hostname.startsWith("gen2.");
  const startLogin = () => {
    void Auth.federatedSignIn().catch((error) => {
      console.error("Hosted UI sign-in failed", error);
    });
  };

  useEffect(() => {
    if (!isGen2Test) {
      startLogin();
    }
  }, []);

  return (
    <div className="flex h-screen items-center justify-center p-6">
      <div className="bubble-card p-6" style={{ width: "min(520px, 94vw)", textAlign: "center" }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 12 }}>
          <img
            src="/logo512.png"
            alt="LEGENDS FIELD logo"
            style={{ width: 120, height: 120, objectFit: "contain", borderRadius: 12 }}
          />
        </div>
        <h1 className="text-2xl font-bold mb-2">LEGENDS FIELD</h1>
        <p className="text-gray-600 mb-4">Protecting Young Arms</p>
        <h2 className="text-lg font-semibold mb-2">{isGen2Test ? "Gen2 Test Login" : "Redirecting to Login..."}</h2>
        <p className="text-gray-600 mb-4">
          {isGen2Test
            ? "This test deployment uses the new Gen2 Cognito and AppSync backend."
            : "If nothing happens, use the button below."}
        </p>
        <button className="bg-red-700 text-white px-5 py-2 rounded-full font-semibold" onClick={startLogin}>
          Sign in
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
